export default "__VITE_ASSET__B_Yqp914__"